import React, { Component } from 'react'
import { findIndex } from 'lodash'

import Header from '@components/Header'
import DrawButton from '@components/DrawButton'
import ViewButton from '@components/ViewButton'
import { Button } from '@components/DrawButton/styles'
import Map from '@components/Map'
import FilterBar from '@components/FilterBar'
import ValuationResult from '@components/ValuationResult'
import SearchBar from '@components/SearchBar'
import RadiusInfo from '@components/RadiusInfo'
import Monitor from '@components/ValuationMonitor'
import Loading from '@components/Loading'
import MapService from '@services/map'
import ValuationService from '@services/valuation'
import { showToast } from '@services/toast'

import {
  ButtonContainer,
  ButtonsContainer,
  Main,
  MapContainer,
  SearchFilter,
  FilterButton,
  InputWrapper,
  IconWrapper,
  ClearFilters,
} from './styles'

import { SearchIcon, FilterIcon } from '@icons'

class Valuation extends Component {
  constructor() {
    super()

    this.state = {
      filterBar: false,
      drawing: false,
      mapOptions: {
        center: [-23.550421, -46.633468],
      },
      city: null,
      valuation: null,
      selectedAddress: '',
      selectedAddressProcessed: '',
      selectedNeighborhood: '',
      selectingPolygon: false,
      radius: 0,
      valuations: [],
      pendingValuations: [],
      loading: false,
      screenLoading: false,
      selectedRealties: [],
      view: {
        neighborhoods: true,
        zones: false,
        satellite: false,
      },
    }

    this.valuationService = new ValuationService()
    this.filters = null
  }

  componentDidMount() {
    this.getValuations()
    this.getAmenities()
    this.verifyInterval = setInterval(this.verifyValuations, 15000)
  }

  initializeMapService = google => {
    this.mapService = new MapService(google, this.forceUpdate)
    this.forceUpdate()
  }

  setSelectedRealties = selectedRealties => {
    this.setState({ selectedRealties })
  }

  setCity = city => {
    this.setState(
      ({ mapOptions, view: { zones, sattelite } }) => ({
        view: {
          neighborhoods: !zones,
          zones,
          satellite: sattelite,
        },
        neighborhoods: undefined,
        city,
        mapOptions: {
          ...mapOptions,
          center: [city.lat, city.lng],
          zoom: city.zoom,
        },
      }),
      async () => {
        this.clearMap()
        await this.loadNeighborhoods(city.id)
        await this.loadZones(city.id)
      },
    )
  }

  selectNeighborhood = (value, label) => {
    const {
      city: { id },
    } = this.state
    this.setState({ selectedNeighborhood: label })
    this.mapService?.selectPolygon(value, id)
    this.validateAddress()
  }

  handleMapChange = mapOptions => {
    this.setState({ mapOptions })
  }

  handleViewChange = view => {
    const { view: previousView } = this.state
    const viewString = JSON.stringify(view)
    const stateViewString = JSON.stringify(previousView)
    if (viewString !== stateViewString) {
      this.setState(
        {
          view: {
            ...view,
            zones: this.state.city?.zoning && view.zones,
          },
        },
        async () => {
          await this.getMapView(this.state.view)
        },
      )
    }
  }

  getMapView = async ({ satellite, neighborhoods, zones }) => {
    if (satellite) this.mapService?.changeToSatelliteView()
    else this.mapService?.changeToRoadmapView()

    if (!this.state.city) return

    const {
      city: { id },
    } = this.state

    this.mapService?.clearMap()

    if (neighborhoods) {
      await this.loadNeighborhoods(id)
    }

    if (zones) {
      await this.loadZones(id)
    }
  }

  loadNeighborhoods = async cityId => {
    const { neighborhoods: shouldRenderNeighborhood } = this.state.view
    if (!this.mapService?.loadedNeighborhoods[cityId]) {
      const neighborhoods = await this.valuationService?.getNeighborhoods(
        cityId,
      )
      this.setState({
        neighborhoods: neighborhoods.map(item => ({
          value: item.id,
          label: item.name,
        })),
      })
      this.mapService?.loadNeighborhoods(
        neighborhoods,
        {
          start: this.startSelectingPolygons,
          stop: this.stopSelectingPolygons,
          cancel: this.cancelSelectingPolygons,
        },
        cityId,
      )
    }
    shouldRenderNeighborhood && this.mapService.renderNeighborhoods(cityId)
  }

  loadZones = async cityId => {
    if (!this.state.city?.zoning) return
    if (!this.mapService?.loadedZones[cityId]) {
      const zones = await this.valuationService?.getZonings(cityId)
      this.mapService.loadZones(
        zones,
        {
          start: this.startSelectingPolygons,
          stop: this.stopSelectingPolygons,
          cancel: this.cancelSelectingPolygons,
        },
        cityId,
      )
    }
    const { zones: shouldRenderZones } = this.state.view
    shouldRenderZones && this.mapService.renderZones(cityId)
  }

  startSelectingPolygons = () => {
    this.setState({ selectingPolygon: true, radius: undefined })
  }

  validateAddress = (nextAddress = null) => {
    const { selectedAddress } = this.state
    const address = nextAddress || selectedAddress

    const polygonSelected = this.mapService.polygons.filter(
      item => !item.isCircle,
    ).length

    const valid =
      !polygonSelected ||
      !address?.lat ||
      this.mapService.polygons[0]?.containsLatLng(address.lat, address.lng)

    if (!valid) {
      this.setState({ selectedAddress: '', selectedAddressProcessed: '' })
      showToast('O endereço deve estar dentro do polígono.', 'warning')
      this.focusSearchBar()
    }
    return valid
  }

  stopSelectingPolygons = () => {
    this.setState({ selectingPolygon: false })
    this.mapService?.stopSelecting()
    this.validateAddress()
  }

  cancelSelectingPolygons = () => {
    const {
      city: { id },
      view,
    } = this.state
    this.setState({ selectingPolygon: false })
    this.mapService?.cancelSelecting()
    this.mapService?.resetMap({ ...view, cityId: id })
  }

  startDrawing = () => {
    this.setState({ drawing: true, radius: undefined })
  }

  stopDrawing = () => {
    this.mapService?.stopDrawing()
    this.setState({ drawing: false })
    this.validateAddress()
  }

  cancelDrawing = () => {
    const { view } = this.state

    this.mapService?.resetMap({ ...view, cityId: this.state.city?.id })
    this.stopDrawing()
  }

  clearMap = () => {
    const { view } = this.state
    const id = this.city?.id
    this.mapService?.resetMap({ ...view, cityId: id })
    this.setState({
      radius: 0,
      selectedAddress: '',
      selectedAddressProcessed: '',
      selectedNeighborhood: '',
    })
  }

  drawFreeHand = () => {
    this.startDrawing()
    this.mapService.drawFreeHand()
  }

  drawPolygon = () => {
    this.startDrawing()
    this.mapService.drawPolygon()
  }

  toggleFilterBar = () => {
    this.setState({ filterBar: !this.state.filterBar })
  }

  setFilterValues = values => {
    const currentFilters = JSON.stringify(this.filters)
    const newFilters = JSON.stringify(values)

    if (newFilters !== currentFilters) this.filters = values
  }

  setLoading = loading => {
    this.setState({ loading })
  }

  submitSearch = async () => {
    const {
      selectedAddress,
      radius,
      selectedRealties,
      realties: { baseSimilarity },
    } = this.state

    if (selectedRealties.length < 5) {
      showToast('Selecione pelo menos 5 anúncios.', 'warning')
      return
    }

    this.setState(
      {
        valuation: undefined,
        realties: undefined,
      },
      () => showToast('Gerando avaliação...'),
    )

    let valuations = [...this.state.valuations]
    let pendingValuations = [...this.state.pendingValuations]
    const { polygons: geometries } = this.mapService
    clearInterval(this.verifyInterval)

    if (this.filters && selectedAddress) {
      try {
        const id = await this.valuationService.valuate(
          {
            ...this.filters,
            ...selectedAddress,
            baseSimilarity,
            selectedRealties,
            geometries: geometries.filter(item => !item.isCircle),
            radius,
          },
          this.setLoading,
        )
        if (id) {
          valuations.unshift({
            id,
            status: 0,
            createdAt: new Date(),
            area: this.filters.area,
            areaPercentMargin: this.filters.areaPercentMargin,
            fullAddress: `${selectedAddress.street}, ${
              selectedAddress.number
            }${(selectedAddress.neighborhood &&
              ' - ' + selectedAddress.neighborhood) ||
              ''}${', ' + selectedAddress.city}`,
          })
          pendingValuations.push(id)

          this.verifyInterval = setInterval(this.verifyValuations, 15000)
          this.setState({
            valuations,
            pendingValuations,
            selectedRealties: [],
          })
        }
      } catch (err) {
        console.error(err)
      }
    } else if (!this.filters) {
      showToast('Selecione filtros', 'warning')
      this.setState({ filterBar: true })
    } else if (!selectedAddress) {
      this.focusSearchBar()
      showToast('Busque um endereço', 'warning')
    }
  }

  getValuations = async () => {
    const valuations = await this.valuationService.getValuations()
    if (valuations) {
      const pendingValuations = valuations
        .filter(item => item.status === 0 || item.status === 1)
        .map(item => item.id)

      this.setState({ valuations, pendingValuations })
    }
  }

  getAdSample = async () => {
    const { selectedAddress, radius } = this.state
    const { polygons: geometries } = this.mapService

    let params = {
      ...this.filters,
      ...selectedAddress,
      geometries: geometries.filter(item => !item.isCircle),
      radius,
    }

    if (this.filters && selectedAddress) {
      try {
        const realties = await this.valuationService.getAdSample(
          params,
          this.setLoading,
        )
        if (realties) {
          this.setState({ realties })
        }
      } catch (err) {
        console.error(err)
      }
    } else if (!this.filters) {
      showToast('Selecione os filtros', 'warning')
      this.setState({ filterBar: true })
    } else if (!selectedAddress) {
      this.focusSearchBar()
      showToast('Busque um endereço', 'warning')
    }
  }

  getAmenities = async () => {
    const amenities = await this.valuationService.getAmenities()
    if (amenities) this.setState({ amenities })
  }

  getValuationById = async id => {
    this.setState({ screenLoading: true })
    const valuation = await this.valuationService.getValuationById(id)

    this.setState({ valuation, screenLoading: false })
  }

  verifyValuations = () => {
    const { pendingValuations, valuations } = this.state
    const final = pendingValuations.length - 1
    let newPending = pendingValuations
    let newValuations = valuations
    pendingValuations.forEach(async (item, index) => {
      const status = await this.valuationService.getValuationStatusById(item)
      if (status === 2 || status === 3) {
        const valuationIndex = findIndex(
          valuations,
          valuation => valuation.id === item,
        )

        newValuations[valuationIndex].status = status
        newPending.splice(index, 1)
      }

      if (index === final) {
        this.setState({
          valuations: newValuations,
          pendingValuations: newPending,
        })
      }
    })
  }

  focusSearchBar = () => {
    const searchBar = document.getElementById('searchBar')
    searchBar.focus()
    searchBar.classList.toggle('autocomplete-input-shake')
    setTimeout(
      () => searchBar.classList.toggle('autocomplete-input-shake'),
      900,
    )
  }

  setRadiusInfo = (selectedAddress, selectedAddressProcessed) => {
    const noPolygonSelected = !this.mapService.polygons.filter(
      item => !item.isCircle,
    ).length

    const contains = this.validateAddress(selectedAddress)

    if (contains) {
      this.panMap(15, [selectedAddress.lat, selectedAddress.lng])
      if (noPolygonSelected) {
        this.mapService.createCircle({
          lat: selectedAddress.lat,
          lng: selectedAddress.lng,
        })
      }
    }

    this.setState(state => ({
      ...state,
      selectedAddress: (contains && selectedAddress) || '',
      selectedAddressProcessed: (contains && selectedAddressProcessed) || '',
      radiusInfo: noPolygonSelected,
    }))

    return contains
  }

  changeRadius = values => {
    const radius = 250
    const { selectedAddress } = this.state
    const parsedRadius = Number(values?.radius) || radius
    this.mapService.createCircle(
      {
        lat: selectedAddress.lat,
        lng: selectedAddress.lng,
      },
      parsedRadius,
    )
    this.panMap(15, [selectedAddress.lat, selectedAddress.lng])
    this.setState({ radiusInfo: false, radius: parsedRadius })
  }

  panMap = (zoom, center) => {
    this.setState(state => ({
      mapOptions: { ...state.mapOptions, zoom, center },
    }))
  }

  handleRecentOnlyClick = async () => {
    if (!this.filters) {
      this.filters = {}
    }
    this.filters.recentOnly = !this.filters.recentOnly
    await this.getAdSample()
  }

  render() {
    const {
      filterBar,
      mapOptions,
      view,
      drawing,
      valuation,
      radiusInfo,
      valuations,
      loading,
      screenLoading,
      amenities,
      neighborhoods,
      selectingPolygon,
      selectedNeighborhood,
      city,
      selectedAddress,
      selectedAddressProcessed,
      realties,
      selectedRealties,
    } = this.state

    return (
      <Main>
        <Header />
        <MapContainer drawing={drawing}>
          <Map
            useMapsApi
            onChange={this.handleMapChange}
            onGoogleApiLoaded={this.initializeMapService}
            streetViewControl
            zoom={mapOptions?.zoom || 13}
            center={mapOptions?.center}
            visualization={view}
          />
        </MapContainer>
        <ButtonsContainer drawing={drawing}>
          {/* TODO: MAEK DIS A COMPONANT */}
          {drawing || selectingPolygon ? (
            <ButtonContainer>
              <Button
                actionBtn
                id="drawButtonApply"
                type="button"
                onClick={
                  drawing ? this.stopDrawing : this.stopSelectingPolygons
                }
              >
                Aplicar
              </Button>
              <Button
                actionBtn
                cancel
                id="drawButtonCancel"
                type="button"
                onClick={
                  drawing ? this.cancelDrawing : this.cancelSelectingPolygons
                }
              >
                Cancelar
              </Button>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <DrawButton
                drawFreeHand={this.drawFreeHand}
                drawPolygon={this.drawPolygon}
              />

              <ViewButton
                view={view}
                submit={this.handleViewChange}
                zonings={city?.zoning}
              />
            </ButtonContainer>
          )}
        </ButtonsContainer>

        {!filterBar && (
          <>
            <SearchFilter active={filterBar}>
              <FilterButton active={filterBar} onClick={this.toggleFilterBar}>
                <FilterIcon />
              </FilterButton>
              <InputWrapper active={filterBar}>
                <IconWrapper active={filterBar}>
                  <SearchIcon gray width={20} height={20} />
                </IconWrapper>
                <SearchBar
                  initialState={selectedAddressProcessed}
                  search={selectedAddress}
                  active={filterBar}
                  mapService={this.mapService}
                  setRadiusInfo={this.setRadiusInfo}
                />
              </InputWrapper>
            </SearchFilter>
            {this.mapService?.polygons?.length !== 0 && (
              <ClearFilters filterActive={filterBar} onClick={this.clearMap}>
                Limpar mapa
              </ClearFilters>
            )}
          </>
        )}

        <Monitor
          drawing={drawing || selectingPolygon}
          filterActive={filterBar}
          valuations={valuations.slice(0, 7)}
          getValuationById={this.getValuationById}
        />

        <FilterBar
          searchInitialState={selectedAddressProcessed}
          active={filterBar}
          mapService={this.mapService}
          setRadiusInfo={this.setRadiusInfo}
          currentCityName={city?.name}
          setCity={this.setCity}
          onClose={this.toggleFilterBar}
          setFilterValues={this.setFilterValues}
          submitFilters={this.getAdSample}
          selectNeighborhood={this.selectNeighborhood}
          selectedNeighborhood={selectedNeighborhood}
          amenities={amenities}
          neighborhoods={neighborhoods}
          loading={loading}
          valuationService={this.valuationService}
        />

        {(valuation || realties) && (
          <ValuationResult
            setSelectedRealties={this.setSelectedRealties}
            selectedRealties={selectedRealties}
            isTemp={!valuation}
            loadingAds={loading}
            filters={this.filters}
            handleRecentOnlyClick={this.handleRecentOnlyClick}
            valuation={valuation || realties?.params}
            realties={(valuation || realties)?.ad_sample}
            baseSimilarity={realties?.baseSimilarity}
            goBack={() => {
              this.setState({
                valuation: undefined,
                realties: undefined,
                baseSimilarity: undefined,
                selectedRealties: [],
              })
            }}
            evaluate={this.submitSearch}
          />
        )}

        {radiusInfo && <RadiusInfo submit={this.changeRadius} />}
        {screenLoading && <Loading />}
      </Main>
    )
  }
}

export default Valuation
